import { useState } from 'react';
import { styled } from '@mui/system';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { PopperMenu } from '@components/Popper';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import { Typography } from '@components/Typography';
import Avatar from '@components/Avatar';
import { formatDateOrEmpty } from '@helpers/dates';
import { getInitialsFull } from '@helpers/userName';
import { AUTHOR } from '@constants/profiles-media';
import { UserIcon } from 'assets/images/icons';
import { ReplyIcon } from 'assets/images/icons';
import { useTranslation } from '@hooks/useTranslation';

const StyledUserIcon = styled(UserIcon)({
    width: '16px !important',
    height: '16px !important',
    '& path': {
        fill: 'var(--text-tertiary)',
        fillOpacity: 1,
    },
});
const StyledReplyIcon = styled(ReplyIcon)({
    width: '16px !important',
    height: '16px !important',
    '& path': {
        fill: 'var(--text-tertiary)',
        fillOpacity: 1,
    },
});

const StyledImageBar = styled(ImageListItemBar)({
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    transition: 'opacity 0.3s',
    opacity: 0,
    height: 72,
    padding: '16px',
    cursor: 'pointer',
    '& .MuiImageListItemBar-titleWrap': {
        padding: 0,
        marginRight: '8px',
    },
});

const MediaInfo = ({ action, data, language }) => {
    const [anchorElTop, setAnchorElTop] = useState(null);
    const { t } = useTranslation();

    const handleOpenTop = event => {
        event.stopPropagation();
        setAnchorElTop(event.currentTarget);
    };
    const handleCloseTop = () => setAnchorElTop(null);

    const isBusiness = data.authorType === AUTHOR.BUSINESS;

    return (
        <>
            <StyledImageBar
                title={
                    <div
                        style={{
                            display: 'grid',
                            gridGap: 8,
                            gridTemplateColumns: '40px calc(100% - 48px)',
                            alignItems: 'center',
                        }}
                    >
                        <div style={{ backgroundColor: '#fff', borderRadius: '50%' }}>
                            {isBusiness ? (
                                <Avatar size="large">
                                    <StyledReplyIcon />
                                </Avatar>
                            ) : (
                                <Avatar size="large">
                                    {!data.authorName ? <StyledUserIcon /> : getInitialsFull(data.authorName, '--')}
                                </Avatar>
                            )}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="subtitle1"
                                sx={{ color: 'var(--text-primary)', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                                {isBusiness ? t('common.business') : data.authorName}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{ color: 'var(--text-secondary)', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                                {[formatDateOrEmpty(data.createdAt, 'dd MMM yyyy, HH:mm', language), data.profileName]
                                    .filter(Boolean)
                                    .join(' - ')}
                            </Typography>
                        </div>
                    </div>
                }
                actionIcon={
                    !!action && (
                        <IconButton sx={{ height: '28px', width: '28px' }} onClick={handleOpenTop}>
                            <MoreVertIcon sx={{ height: '24px', width: '24px' }} />
                        </IconButton>
                    )
                }
            />
            {anchorElTop && !!action && (
                <ClickAwayListener onClickAway={handleCloseTop} mouseEvent="onMouseDown">
                    <PopperMenu anchorEl={anchorElTop} open={!!anchorElTop}>
                        <MenuItem
                            onClick={e => {
                                e.stopPropagation();
                                action.run();
                                handleCloseTop();
                            }}
                            sx={{ minWidth: '150px' }}
                        >
                            <Typography variant="body2">{t(action.labelKey)}</Typography>
                        </MenuItem>
                    </PopperMenu>
                </ClickAwayListener>
            )}
        </>
    );
};

export default MediaInfo;
